import React from "react";
import { Check, CheckCheck } from "lucide-react";
import "./ChatDeliveryTicks.scss";

/** @param {object | null | undefined} message */
export function getOutgoingReceiptStatus(message) {
  const readBy = Array.isArray(message?.readBy) ? message.readBy : [];
  const deliveredTo = Array.isArray(message?.deliveredTo) ? message.deliveredTo : [];
  if (readBy.length > 0) return "read";
  if (deliveredTo.length > 0) return "delivered";
  return "sent";
}

/**
 * WhatsApp-style delivery ticks: single grey (sent), double grey (delivered), double blue (read).
 * @param {{ status: "sent" | "delivered" | "read"; theme?: "light" | "mint" | "onDark" | "adminPatient" | "onTeal" }} props
 */
export default function ChatDeliveryTicks({ status, theme = "light" }) {
  const label = status === "read" ? "Read" : status === "delivered" ? "Delivered" : "Sent";
  const Icon = status === "sent" ? Check : CheckCheck;
  const size = 15;
  const stroke = 2.35;

  return (
    <span
      className={`chat-delivery-ticks chat-delivery-ticks--${status} chat-delivery-ticks--${theme}`.trim()}
      aria-label={label}
      role="img"
    >
      <Icon size={size} strokeWidth={stroke} aria-hidden />
    </span>
  );
}
